/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Grid position and size of the graph
*/
export class DashboardGraphLayout {
  'x'?: number;
  'y'?: number;
  'w'?: number;
  'h'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "x",
      "baseName": "x",
      "type": "number",
      "format": ""
    },
    {
      "name": "y",
      "baseName": "y",
      "type": "number",
      "format": ""
    },
    {
      "name": "w",
      "baseName": "w",
      "type": "number",
      "format": ""
    },
    {
      "name": "h",
      "baseName": "h",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DashboardGraphLayout.attributeTypeMap;
  }

  public constructor() {
  }
}

